// TelcoTrack — Umístění bábovky (milestone Připravená bábovka).

export const BABOVKA_PLACEMENTS = ['V_OBJEKTU', 'PRED_OBJEKTEM'] as const;
export type BabovkaPlacement = (typeof BABOVKA_PLACEMENTS)[number];

export const BABOVKA_PLACEMENT_LABELS: Record<BabovkaPlacement, string> = {
  V_OBJEKTU: 'V objektu',
  PRED_OBJEKTEM: 'Před objektem',
};

export function isBabovkaPlacement(value: string | null | undefined): value is BabovkaPlacement {
  return (BABOVKA_PLACEMENTS as readonly string[]).includes((value ?? '').trim());
}

export function formatBabovkaPlacementLabel(placement: string | null | undefined): string {
  const key = (placement ?? '').trim();
  if (isBabovkaPlacement(key)) return BABOVKA_PLACEMENT_LABELS[key];
  return key;
}

/** BUDOVA milestone Připravená bábovka — umístění z metadata / customFields. */
export function readBabovkaPlacementFromMetadata(
  meta: Record<string, unknown> | null | undefined,
): BabovkaPlacement | null {
  if (!meta || typeof meta !== 'object') return null;
  const custom =
    meta['customFields'] && typeof meta['customFields'] === 'object'
      ? (meta['customFields'] as Record<string, unknown>)
      : meta;
  const raw = String(custom['babovkaPlacement'] ?? meta['babovkaPlacement'] ?? '').trim();
  return isBabovkaPlacement(raw) ? raw : null;
}
